
import UserHeader from "@/components/auth/UserHeader";
import Logo from "@/components/meeting/Logo";
import FeaturesGrid from "@/components/features/FeaturesGrid";

interface HeaderProps {
  isVisible: boolean;
  isAuthenticated: boolean;
  userEmail: string | null;
  onToggleVisibility: () => void;
  onSignOut: () => void;
}

const Header = ({
  isVisible,
  isAuthenticated,
  userEmail,
  onToggleVisibility,
  onSignOut
}: HeaderProps) => {
  return (
    <header className="flex-none transition-all duration-300 ease-in-out pt-4">
      <div className="flex flex-col items-center">
        <div className={`w-full transition-all duration-300 overflow-hidden ${
          isVisible ? 'opacity-100 max-h-[300px]' : 'opacity-0 max-h-0'
        }`}>
          {isAuthenticated && userEmail && (
            <UserHeader userEmail={userEmail} onSignOut={onSignOut} />
          )}

          <div className="text-center mb-8">
            <div className="flex items-center justify-center gap-4 mb-1">
              <h1 className="text-5xl font-bold text-primary">
                Alfie
              </h1>
            </div>
            <p className="text-sm text-muted-foreground mb-8">
              Alfie here, at your service, to book your Google Calendar meetings
            </p>
          </div>

          <FeaturesGrid />
        </div>
      </div>
    </header>
  );
};

export default Header;
